import { AcumaticaRequestOptions, AcumaticaService } from '../acumatica.service';
import { AcumaticaEntity, AcumaticaEntityService } from './acumatica-entity';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Acumatica } from '../acumatica-field-decorator';

@Injectable({
    providedIn: 'root'
})

export class KitSpecificationService extends AcumaticaEntityService {
    constructor(
        protected acumatica: AcumaticaService
    ) {
        super(acumatica, 'KitSpecification', KitSpecification);
    }

    get(
        KitInventoryID: string,
        options?: AcumaticaRequestOptions
    ): Observable<KitSpecification>;
    get(
        KitInventoryID: string,
        RevisionID: string,
        options?: AcumaticaRequestOptions
    ): Observable<KitSpecification>;
    get(
        p1: string,
        p2: AcumaticaRequestOptions | string | undefined,
        p3?: AcumaticaRequestOptions
    ): Observable<KitSpecification> {
        let options: AcumaticaRequestOptions | undefined;
        if(typeof p2 === 'string') {
            p1 = p1 + '/' + p2;
            options = p3;
        }
        else {
            options = p2;
        }

        return new Observable<KitSpecification>(observer => {
            super.getEntity(p1, {
                ...{ loader: { message: "Getting Binder Contents" }, expand: 'StockComponents' },
                ...options
            }).subscribe(observer);
        })
    }
}

export class KitStockComponent extends AcumaticaEntity {
    @Acumatica('StockInventoryID') InventoryID!: string;
    @Acumatica() UOM: string | null = null;
    @Acumatica() ComponentQty: number | null = null;
    @Acumatica() Description: string | null = null;
    @Acumatica() ItemStatus: string | null = null;
    @Acumatica() LifeCycle: string | null = null;
    @Acumatica() ItemClassID: string | null = null;

    get componentType(): KitStockComponentTypeEnum | undefined {
        switch (this.ItemClassID) {
            case '50': return KitStockComponentTypeEnum.MemoSample;
            case 'CD': return KitStockComponentTypeEnum.Card;
            case 'EBND': return KitStockComponentTypeEnum.BinderShell;
            default: return undefined;
        }
    }
}

export class KitSpecification extends AcumaticaEntity {
    @Acumatica('KitInventoryID') InventoryID?: string;
    @Acumatica() RevisionID!: string;
    @Acumatica() Active!: boolean;
    @Acumatica() Description?: string;

    @Acumatica(KitStockComponent) StockComponents: KitStockComponent[] = [];

    constructor(init: Partial<KitSpecification>) {
        super();
        Object.assign(this, init);
    }
}

export enum KitStockComponentTypeEnum {
    Card,
    BinderShell,
    MemoSample
}